module.exports = __webpack_public_path__ + "img/img3.d0ad1752.png";